/* src/app/pages/new-analysis/ap-report/ap-report.component.scss */
.mat-mdc-form-field {
  --mat-mdc-form-field-floating-label-scale: 0.75;
  display: block;
  flex-direction: column;
  min-width: 0;
  text-align: left;
}
/*# sourceMappingURL=ap-report.component.css.map */
